import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgChartsModule, ThemeService } from "ng2-charts";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { DougnhutChartComponent } from "./components/dougnhut-chart/dougnhut-chart.component";
import { FilterableListComponent } from "./components/filterable-list/filterable-list.component";
import { FilterableTableComponent } from "./components/filterable-table/filterable-table.component";
import { PaginatorComponent } from "./components/paginator/paginator.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { ToastComponent } from "./components/toast/toast.component";
import { SpinnerService } from "./services/spinner.service";
import { UtilsService } from "./services/utils.service";
import { SharedComponentsComponent } from "./shared-components.component";
import { BarChartComponent } from "./components/bar-chart/bar-chart.component";

import { NgApexchartsModule } from "ng-apexcharts";
import { StackedBarChartComponent } from "./components/stacked-bar-chart/stacked-bar-chart.component";
import { SimpleDougnhutChartComponent } from "./components/simple-dougnhut-chart/simple-dougnhut-chart.component";
import { SplineAreaChartComponent } from "./components/spline-area-chart/spline-area-chart.component";
import { BasicTimelineChartComponent } from "./components/basic-timeline-chart/basic-timeline-chart.component";
import { AdvancedTimelineChartComponent } from "./components/advanced-timeline-chart/advanced-timeline-chart.component";
import { GroupedBarChartComponent } from "./components/grouped-bar-chart/grouped-bar-chart.component";
import { MultiSelectListComponent } from "./components/checkbox-multiselect-list/checkbox-multiselect-list.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ViewerPdfComponent } from "./components/viewer-pdf/viewer-pdf.component";
import { ViewerPdfToolbarComponent } from "./components/viewer-pdf/toolbar/toolbar.component";
import { StepperComponent } from "./components/stepper/stepper.component";
// import { TooltipComponent } from './components/tooltip/tooltip.component';
// import { TooltipDirective } from './directives/tooltip.directive';

export const translateLoader = function (http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
};

// @dynamic
@NgModule({
  declarations: [
    SharedComponentsComponent,
    SpinnerComponent,
    ToastComponent,
    PaginatorComponent,
    FilterableListComponent,
    FilterableTableComponent,
    MultiSelectListComponent,
    CheckboxComponent,
    DougnhutChartComponent,
    BarChartComponent,
    StackedBarChartComponent,
    SimpleDougnhutChartComponent,
    SplineAreaChartComponent,
    BasicTimelineChartComponent,
    AdvancedTimelineChartComponent,
    GroupedBarChartComponent,
    ViewerPdfComponent,
    ViewerPdfToolbarComponent,
    StepperComponent,
    // TooltipComponent,
    // TooltipDirective
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgChartsModule,
    NgApexchartsModule,
    PdfViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [SpinnerService, UtilsService, ThemeService],
  exports: [
    SharedComponentsComponent,
    SpinnerComponent,
    ToastComponent,
    PaginatorComponent,
    FilterableListComponent,
    FilterableTableComponent,
    MultiSelectListComponent,
    CheckboxComponent,
    DougnhutChartComponent,
    BarChartComponent,
    StackedBarChartComponent,
    SimpleDougnhutChartComponent,
    SplineAreaChartComponent,
    BasicTimelineChartComponent,
    AdvancedTimelineChartComponent,
    GroupedBarChartComponent,
    ViewerPdfComponent,
    ViewerPdfToolbarComponent,
    StepperComponent,
  ],
  bootstrap: [SharedComponentsComponent],
})
export class SharedComponentsModule {}
